module.exports = __webpack_public_path__ + "static/media/GTBSProjectPrevieww1870@2x.bcfee241.webp";